import axios from './http'
var qs = require('qs');

//新增 cvc合同接口

// 获取企业库数据
export function httpEnterpriseList(data) {
    return axios({
        url: '/adminapi/enterprise/enterprise/list',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
// 检测产品分类下拉
export function httpCommonSelect(data) {
    return axios({
        url: '/adminapi/common/select',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}


// 获取省 区
export function httpArea(data) {
    return axios({
        url: '/adminapi/common/area',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
// 获取下拉
export function httpApplyformSelect(data) {
    return axios({
        url: '/adminapi/applyform/applyform/select',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
// 获取产品小类大类
export function httpClassifySelect(data) {
    return axios({
        url: '/adminapi/applyform/applyform/classify_select',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}

// 获取会签人 
export function httpReviewerSelect(data) {
    return axios({
        url: '/adminapi/permission/menu/reviewer_select',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
export function httpTextPro(data) {
    return axios({
        url: '/adminapi/common/testproject',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
// 上传
export function httpUpload(data) {
    return axios({
        url: '/adminapi/applyform/applyform/upload',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
// 删除上传
export function httpUploadDe(data) {
    return axios({
        url: '/adminapi/applyform/applyform/upload-de',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
// 下载pdf
export function httpDownload(data) {
    return axios({
        url: '/adminapi/scheduling/scheduling-record-review/download',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
// 上传文件
export function httpUploads(data) {
    return axios({
        url: '/adminapi/upload/upload/uploads',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
export function httpFormAdd(data) {
    return axios({
        url: '/adminapi/applyform/applyform/add',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}
// 获取详情
export function httpDetails(data) {
    return axios({
        url: '/adminapi/applyform/inquiry/details',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data
    })
}


//end